import { useEffect } from 'react';
import { LINKS_EXTERNOS } from '../data/catalogoDestaque';

/** Encaminha para o site oficial já desenvolvido (tutoriais.lunins.org). */
export default function Tutoriais() {
  useEffect(() => {
    window.location.replace(LINKS_EXTERNOS.tutoriais);
  }, []);
  return null;
}
